export const OPEN_PUBLISHED_DATE_UPDATE_MODAL = 'OPEN_PUBLISHED_DATE_UPDATE_MODAL';
export const CLOSE_PUBLISHED_DATE_UPDATE_MODAL = 'CLOSE_PUBLISHED_DATE_UPDATE_MODAL';

function openModal(index, version) {
  return {
    type: OPEN_PUBLISHED_DATE_UPDATE_MODAL,
    index,
    version
  };
}

function closeModal() {
  return {
    type: CLOSE_PUBLISHED_DATE_UPDATE_MODAL
  };
}

export function showPublishedDateUpdate(index, version) {
  return dispatch => dispatch(openModal(index, version));
}

export function hidePublishedDateUpdate() {
  return dispatch => dispatch(closeModal());
}
